module.exports = __webpack_public_path__ + "img/cjyl.c1eaad6c.png";